import {createAction, nanoid} from '@reduxjs/toolkit'
import {DiagnosticResponseType} from 'interfaces'

type ToggleEndpointRequest = {
  disableOption?: boolean
  debugMode?: boolean
  agentUUID: string
  userUUID: string
}

export const toggleEndpoint = createAction(
  'toggleEndpoint',
  (
    payload: ToggleEndpointRequest,
  ): {payload: ToggleEndpointRequest; meta: {requestId: string}} => ({
    payload,
    meta: {requestId: nanoid()},
  }),
)
export type ToggleEndpointResult = ToggleEndpointRequest & {
  requestId: string
  message: string
}
export const toggleEndpointSuccess = createAction<ToggleEndpointResult>(
  'toggleEndpointSuccess',
)
export const toggleEndpointFailure = createAction<ToggleEndpointResult>(
  'toggleEndpointFailure',
)

export const getAssociatedUsers = createAction<{
  agentUUID: string
}>('getAssociatedUsers')
export const getAssociatedUsersSuccess = createAction<{
  users: {
    userId: string
    policyName: string
  }[]
}>('getAssociatedUsersSuccess')
export const getAssociatedUsersFailure = createAction<string>(
  'getAssociatedUsersFailure',
)

export const getDiagnosticResult = createAction<{
  agent: string
}>('getDiagnosticResult')
export const getDiagnosticResultSuccess = createAction<DiagnosticResponseType>(
  'getDiagnosticResultSuccess',
)
export const getDiagnosticResultFailure = createAction<string>(
  'getDiagnosticResultFailure',
)
